<template>
    <div class="role">
        <div style="width: 11.28rem;height: 0.64rem;background: white;border-radius: 6px;margin-bottom: 0.12rem;margin-left: 0.12rem">
            <el-row style="padding-top: 16px;margin-left: 16px;margin-right: 16px">
                <el-col :span="5">
                    <el-input v-model="ruleForm.roleName" style="width: 96%" :placeholder="mainLanguages[lang]['user_14']" />
                </el-col>
                <el-col :span="14" style="text-align: right">
                    <div style="margin-top: -0.5rem">
                        <el-button type="danger" icon="search" @click="handleQuery">{{mainLanguages[lang]['channel_17']}}</el-button>
                        <el-button type="danger" plain icon="refresh" @click="refreshQuery">{{mainLanguages[lang]['channel_18']}}</el-button>
                    </div>
                </el-col>
            </el-row>
        </div>
        <div style="width: 11.28rem;height: 9.70rem;background: white;border-radius: 6px;margin-bottom: 0.12rem;margin-left: 0.12rem;padding-top: 0.01rem">
            <div style="text-align: right;margin-right: 0.16rem;margin-top: -0.4rem">
                <el-button type="danger" @click="toRoute('/personal/role/add')">{{mainLanguages[lang]['user_15']}}</el-button>
            </div>
            <el-table v-loading="loading" :data="tableData" :header-cell-style="{background:'#F1F1F1'}" @selection-change="handleSelectionChange" style="margin: 0.16rem;margin-top: -0.2rem;width: 97%;border: 0.5px solid #C2C2C2;box-sizing: border-box;border-radius: 4px;">
                <el-table-column align="center" type="selection" width="40"  />
                <el-table-column :label="mainLanguages[lang]['order_25']" align="center" type="index" width="55"  />
                <el-table-column :label="mainLanguages[lang]['user_16']" align="left" prop="roleName" width=""  />
                <el-table-column :label="mainLanguages[lang]['user_17']" align="left" prop="roleDesc" width=""  />
                <el-table-column :label="mainLanguages[lang]['user_12']" align="left" prop="createTime" width="130" />
                <el-table-column :label="mainLanguages[lang]['order_41']" align="center" width="80" >
                    <template #default="scope">
                        <span style="color: #b23a3a;cursor: pointer" @click="toRoute('/personal/role/add',scope.row)">编辑</span>
                    </template>
                </el-table-column>
            </el-table>
            <!--<div style="display: flex; justify-content: right;margin-right: 10px;margin-top: 20px">-->
                <!--<el-pagination background layout="total, prev, pager, next" :total="tableSize" @size-change="" @current-change="handleCurrentChange" v-model:page-size="pageSize" class="mt-4"/>-->
            <!--</div>-->
        </div>
    </div>
</template>

<script setup name="roleIndex">
    import { ref,reactive,toRefs,nextTick,unref,getCurrentInstance,watch,onActivated,inject  } from 'vue';
    import { useRouter } from 'vue-router'
    import {getBillCustomer,downloadExportBill,downloadExportBatchBill,getCustUserList,getUserInfo,getRoleList} from "../../../api/website";
    import {elMessgae} from "../../../css/Sugar";
    import {blobValidate} from "../../../utils/hubo";
    import errorCode from '@/utils/errorCode'
    import { ElNotification , ElMessageBox, ElMessage, ElLoading } from 'element-plus'
    import Cookies from 'js-cookie'
    import {mainLanguages} from "../../../utils/languages";

    const router = useRouter();
    const ruleForm = ref({});
    const tableData = ref([]);
    const pageSize = ref(20);
    const currentPage = ref(1);
    const balanceDate = ref([]);
    const loading = ref(false);
    const downloadModel = ref(false);
    const ruleForm2 = ref({});
    const globalRow = ref({});
    const globalSelection = ref([]);
    const isBatch = ref(false);
    const tableSize = ref(0);
    const languagesOption = ref([
        {name:'中文简体',abbr:'zh',img:''},
        {name:'English',abbr:'en',img:''},
    ]);
    const languagesName = ref('中文简体');
    const lang = ref('zh');

    if(Cookies.get('languages')!==undefined){
        if(Cookies.get('languages').indexOf('zh')!==-1||Cookies.get('languages').indexOf('en')!==-1){
            lang.value = Cookies.get('languages');
            languagesName.value = languagesOption.value.find(shit => {return shit.abbr===Cookies.get('languages')}).name;
        }else {
            let currentLanguage = navigator.language || navigator.userLanguage;
            if(currentLanguage.indexOf('zh')!==-1){
                languagesName.value = '中文简体';
                Cookies.set('languages','zh');
                lang.value = 'zh';
            }else {
                languagesName.value = 'English';
                Cookies.set('languages','en');
                lang.value = 'en';
            }
        }
    }else {
        languagesName.value = '中文简体';
        Cookies.set('languages','zh');
        lang.value = 'zh';
    }

    function handleSelectionChange(selection) {
        globalSelection.value = selection;
    }

    function batchDownload() {
        if(globalSelection.value.length>0){
            downloadModel.value = true;
            isBatch.value = true;
        }else {
            elMessgae("请至少勾选一项数据","error");
        }
    }

    function handleQuery() {
        ruleForm.value.balanceDateBegin = balanceDate.value[0]||undefined;
        ruleForm.value.balanceDateEnd = balanceDate.value[1]||undefined;
        getList();
    }

    function refreshQuery() {
        ruleForm.value.orderCode = undefined;
        currentPage.value = 1;
        pageSize.value = 20;
        balanceDate.value = [];
        ruleForm.value.balanceDateBegin = undefined;
        ruleForm.value.balanceDateEnd = undefined;
        getList();
    }

    setTimeout(() => {
        ruleForm.value.billState = router.currentRoute._value.query.billState;
        getUserInfo()
            .then(resp => {
                ruleForm.value.customerId = resp.data.customerId;
                getList();
            })
    },100)

    function getList() {
        getRoleList(Object.assign(ruleForm.value))
            .then(resp => {
                tableData.value = resp.data;
                // tableSize.value = resp.data.total;
            })
    }

    function handleSizeChange(val) {
        pageSize.value = val;
        getList();
    }

    function handleCurrentChange(val) {
        currentPage.value = val;
        getList();
    }

    function toRoute(path,row) {
        router.push({path:path,query:{activeIndex:7,row:JSON.stringify(row)}});
    }
</script>

<style lang="less">
    .role{
    .el-menu{
        --el-menu-border-color:#ffffff;
    span{
        margin-left: 0.20rem;
        font-size: 0.14rem;
        font-weight: bold;
    }
    }

    .el-menu-item{
        height: 0.44rem;
    }

    .el-menu-item{
        border-left: 3px solid rgba(0,0,0,0);
        border-bottom: 2px solid transparent;
        border-top: 2px solid transparent;
        border-bottom-right-radius: 6px;
        border-top-right-radius: 6px;
    }

    .el-menu-item.is-active{
        color: #C83A3A;
        background: #FFF3F3;
        border-left: 3px solid #C83A3A;
        border-bottom: 2px solid transparent;
        border-top: 2px solid transparent;
        border-bottom-right-radius: 6px;
        border-top-right-radius: 6px;
    }
    .el-menu-item:hover{
        color: #C83A3A;
        background: #FFF3F3;
    }

    .el-table{
        --el-table-border-color: '#000000';
        --el-table-border: 0.5px solid #C2C2C2;
    }

    .el-table thead{
        color: black;
        font-size: 0.12rem;

    }

    .el-table .el-table__cell{
        padding: 0rem 0;
    }

    .el-table td.el-table__cell div{
        font-size: 0.12rem;
        color: rgba(0,0,0, 1);
        font-weight: 500;
        font-family: Bahnschrift;
    }

    .el-pagination.is-background .el-pager li:not(.is-disabled).is-active{
        background-color: #D94040;
    }

    .el-pagination{
        /*--el-pagination-hover-color:#D94040*/
    }
    .el-table__body-wrapper .el-table-column--selection .el-checkbox, .el-table__header-wrapper .el-table-column--selection .el-checkbox{
        margin-top: 0.07rem;
    }

    .el-tag.el-tag--danger{
        --el-tag-text-color: #C83A3A;
        --el-tag-bg-color: rgba(252,243,244);
        border: none;
    }
    .el-tag.el-tag--primary{
        --el-tag-text-color: rgba(48,90,174);
        --el-tag-bg-color: rgba(171, 193, 252, 0.13);
        border: none;
    }

    .el-tag.el-tag--success{
        --el-tag-text-color: rgb(24, 153, 14);
        --el-tag-bg-color: rgba(233,246,233,0.5);
        border: none;
    }
    }
</style>